import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSortingComponent } from './custom-sorting.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [CustomSortingComponent],
    exports: [CustomSortingComponent],
    imports: [
        CommonModule,
        NgSelectModule,
        FormsModule,
        I18nModule,
        CustomIconsModule,
        RouterModule,
    ]
})
export class CustomSortingModule {}
